var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0437 23.1226C10.5514 23.6852 9.88369 24.0013 9.1875 24.0013C8.49131 24.0013 7.82363 23.6852 7.33134 23.1226C6.83906 22.56 6.5625 21.797 6.5625 21.0013H11.8125C11.8125 21.797 11.5359 22.56 11.0437 23.1226ZM10.4343 1.03147C10.4916 1.2306 10.5118 1.44124 10.4934 1.64981C13.4925 2.34131 15.75 5.37131 15.75 9.00131C15.75 9.23262 15.7629 9.57648 15.7907 10.0009C15.7563 10.0003 15.722 10 15.6875 10C12.3738 10 9.6875 12.6863 9.6875 16C9.6875 17.3068 10.1053 18.516 10.8145 19.5013H0C1.96875 18.0013 2.625 10.6483 2.625 9.00131C2.62519 7.27117 3.14857 5.59427 4.1065 4.25456C5.06444 2.91485 6.39807 1.99466 7.88156 1.64981C7.86324 1.44124 7.88338 1.2306 7.94067 1.03147C7.99796 0.832343 8.09113 0.649147 8.21418 0.493699C8.33723 0.338252 8.48742 0.214004 8.65506 0.128969C8.82271 0.0439342 9.00408 0 9.1875 0C9.37092 0 9.55229 0.0439342 9.71994 0.128969C9.88758 0.214004 10.0378 0.338252 10.1608 0.493699C10.2839 0.649147 10.377 0.832343 10.4343 1.03147Z",
    fill: "#00948B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6875,
    cy: 16,
    r: 4,
    fill: "#F35B37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications-icon.3e2223c35ff33cf10f78f243dd475651.svg";
export { ForwardRef as ReactComponent };